import { render, staticRenderFns } from "./DialogBar.vue?vue&type=template&id=03edd814"
import script from "./DialogBar.vue?vue&type=script&lang=js"
export * from "./DialogBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports